import axiosConfig from "./axiosConfig";

// Opens the insured's ixperience booking page (/ega/<token>) for a folder.
// The tab is opened before the request so the browser does not block it.
export const openEgaLink = (folderId, locationIds = []) => {
  const tab = window.open("", "_blank");
  const fail = () => {
    if (tab) tab.close();
    alert("Lien de prise de rendez-vous indisponible");
  };

  axiosConfig("EGA/get-ega-link", {
    data: { folderId, dataId: locationIds },
  })
    .then((res) => {
      if (!res.data.success || !res.data.url) return fail();
      if (tab) {
        tab.opener = null;
        tab.location.href = res.data.url;
      } else {
        window.location.href = res.data.url;
      }
    })
    .catch(fail);
};
